import type { CustomFormats } from "react-intl";

export default {
	number: {
		currency: {
			style: "currency",
		},
	},
} as CustomFormats;
